import { shallowEqualArrays } from '../lang/shallow-equal';
import { isFn } from '../lang/is';
import mitt from 'mitt';
/**
 * 异步任务工具类
 * 主要使用场景：
 * 1. 一个或者多个异步任务(如请求)依赖另一个异步任务的状态和返回数据
 * 2. 对异步任务的执行进行更精细化的控制，比如在多个地方都有可能调用，但是只需要执行一次，第二次可以复用，可以使用 job.once()；又或者根据参数状态(参考 react 的 deps)是否变化决定是否执行还是复用上一次的结果
 * @example
 * const fetchLoginUserJob = new Job(() => ...)
 * const fetchDataJob = new Job(async () => {
 *   const data = await fetchData()
 *   let user = await fetchLoginUserJob.wait() // 等待 fetchLoginUserJob 执行完成
 *    // handle data & user, e.g. log data & user.id
 *    log('viewpage', { id: data.id, userId: user && user.id})
 * })
 * // 同时执行两个异步函数，
 * fetchLoginUserJob.call()
 * fetchDataJob.call()
 *
 */
var Job = /** @class */ (function () {
    function Job(_job) {
        this._job = _job;
        this._lastDeps = [];
        this._mitt = mitt();
    }
    Object.defineProperty(Job.prototype, "result", {
        get: function () {
            return this._result;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 等待执行结果，该方法不会触发执行, 但是会返回一个只有调用过 once/call 才会 resolve 的 Promise
     */
    Job.prototype.wait = function () {
        var _this = this;
        if (this._result) {
            return this._result;
        }
        return new Promise(function (res) {
            var cb = function (r) {
                _this.off('exec', cb);
                res(r);
            };
            _this.on('exec', cb);
        });
    };
    Job.prototype.on = function (event, cb) {
        this._mitt.on(event, cb);
    };
    Job.prototype.off = function (event, cb) {
        this._mitt.off(event, cb);
    };
    /** 如果已经执行过，则直接返回上一次执行的 Promise, 否则先执行再返回 Promise */
    Job.prototype.once = function () {
        if (!this._result) {
            this.call();
        }
        return this._result;
    };
    Job.prototype.only = function (job, deps) {
        if (isFn(job)) {
            this._job = job;
            deps = deps || [];
        }
        else {
            deps = job;
        }
        if (shallowEqualArrays(this._lastDeps, deps)) {
            return this.once();
        }
        this._lastDeps = deps;
        return this.call();
    };
    /** 执行并返回 Promise */
    Job.prototype.call = function () {
        this._result = Promise.resolve(this._job());
        this._mitt.emit('exec', this._result);
        return this._result;
    };
    return Job;
}());
export { Job };
//# sourceMappingURL=job.js.map